"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicateProductsBySku = void 0;
function deduplicateProductsBySku(products) {
    return Array.from(new Map(products.map((product) => [product.sku, product])).values());
}
exports.deduplicateProductsBySku = deduplicateProductsBySku;
